import Countdown from './component';

export default Countdown;
